import React from 'react';
import { motion } from 'framer-motion';
export function Pain() {
  return <section className="bg-forest py-20 md:py-28" data-id="element-250">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-252">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-warm-white mb-12 text-center leading-tight" data-id="element-253">
            Tu cuerpo necesita equilibrio,{' '}
            <span className="italic text-gold-light" data-id="element-254">no castigo.</span>
          </h2>

          <div className="space-y-7 text-warm-white/90 text-lg md:text-xl leading-relaxed" data-id="element-255">
            <p data-id="element-256">
              Con el tiempo, factores como el{' '}
              <strong className="text-warm-white" data-id="element-257">estrés</strong>, el{' '}
              <strong className="text-warm-white" data-id="element-258">descanso irregular</strong> y
              los{' '}
              <strong className="text-warm-white" data-id="element-259">cambios hormonales</strong>{' '}
              pueden influir en cómo muchas mujeres experimentan energía,
              bienestar y cambios físicos.
            </p>

            <div className="border-l-4 border-gold-light pl-6 my-10" data-id="element-260">
              <p className="font-serif text-2xl md:text-3xl italic text-gold-light leading-snug" data-id="element-261">
                Por eso, hacer más esfuerzo no siempre genera mejores
                resultados.
              </p>
            </div>

            <p className="text-xl md:text-2xl font-medium text-warm-white" data-id="element-262">
              A veces, el cuerpo necesita una estrategia más alineada con esta
              nueva etapa.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}